import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEmployee } from "src/models/Stores/Employee.models";

interface EmployeeState {
  employees: IEmployee[];
  employeeToEdit: IEmployee | null;
}

const initialState: EmployeeState = {
  employees: [],
  employeeToEdit: null,
};

const employeeSlice = createSlice({
  name: "Employee",
  initialState,
  reducers: {
    setEmployeeList: (state, action: PayloadAction<IEmployee[]>) => {
      state.employees = action.payload;
    },
    concatListEmployee: (
      state: EmployeeState,
      action: PayloadAction<IEmployee[]>
    ) => {
      state.employees = [...state.employees.concat(action.payload)];
    },
    setEmployeeToEdit: (state, action: PayloadAction<IEmployee | null>) => {
      state.employeeToEdit = action.payload;
    },
    addEmployee: (state, action: PayloadAction<IEmployee>) => {
      state.employees.push(action.payload);
    },
    updateEmployee: (state, action: PayloadAction<IEmployee>) => {
      let itemIndex = state.employees.findIndex(
        item => item.employeeId === action.payload.employeeId
      );
      if (itemIndex !== -1) state.employees[itemIndex] = action.payload;
    },
    deleteEmployee: (state, action: PayloadAction<number>) => {
      const newArray = state.employees.filter(
        item => item.employeeId !== action.payload
      );
      state.employees = newArray;
    },
  },
});

export const {
  setEmployeeList,
  concatListEmployee,
  setEmployeeToEdit,
  addEmployee,
  updateEmployee,
  deleteEmployee,
} = employeeSlice.actions;

export default employeeSlice.reducer;
